/* Copyright(c) 2019 APSS Media Pvt. Ltd.
*  All Rights Reserved
*/
export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';